<template>
  <section :class="$style.open_hour">
    <div :id="$style.opening_hours">
      <div :id="$style.sub_title">
        <h2>3. 松井秀喜・ホームランの残像 <br><h3>(17分)</h3></h2>
      </div>
    </div>
    <div :class="$style.middle_title">
      〜 長嶋茂雄監督と歩んだスラッガーへの道 〜
    </div>
    松井秀喜が巨人時代、長嶋監督からマンツーマンで指導を受け巨人の不動の4番打者へと成長した過程で育まれた師弟の深い絆をテーマに巨人時代の豊富な試合映像とともに紹介しています。
  </section>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "OpenHourVisual",
  components: {

  }
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  .open_hour {
    text-align: center;

    #opening_hours {
      margin-bottom: 20px;
      #time {
        background-color: rgba(63, 107, 120, 1);
        color: #fff;
        height: 35px;
        font-size: 19px;
        display: flex;
        align-items: center;
        padding-left: 20px;
      }
      h3 {
        font-size: 20px;
      }

    }
    .middle_title {
      font-size: 18px;
      color: #46ca0e;
      margin-bottom: 8px;
      text-align: center;
    }
  }
}
@media only screen and (min-width: 1024px) {
  .open_hour {
    text-align: center;

    #opening_hours {
      margin-bottom: 20px;
      #time {
        background-color: rgba(63, 107, 120, 1);
        color: #fff;
        height: 35px;
        font-size: 19px;
        display: flex;
        align-items: center;
        padding-left: 20px;
      }

      #sub_title {
        color: #3b342a;
        h3 {
            font-size: 23px;
        }
      }
    }
    .middle_title {
      font-size: 18px;
      color: #46ca0e;
      margin-bottom: 8px;
      text-align: center;
    }
  }
}
</style>
